import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EvvtimesheetComponent } from './evvtimesheet.component';

const routes: Routes = [{ path: '', component: EvvtimesheetComponent, pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EvvtimesheetRoutingModule { }
